// locale-links.js  (stopgap version)
//
// Problem this fixes: internal links on the storefront carry the wrong
// language prefix (for example /en/pages/... or /en/cart on a /fr or German
// page). This script takes the language from the URL the visitor is actually
// on, not from Shopify's routes value, and rewrites internal links to match:
//   - wrong prefix  (/en/... on a /fr page)      -> the page's own prefix
//   - bare content links (/pages/x) on /fr, /it, /tr, /en pages -> prefixed
// It also covers links added later by JavaScript (cart drawer, search) and
// fixes a link at click time as a last resort.
//
// Never touched: language-switcher links (hreflang / lang attributes, links
// inside a localization form, inside elements whose class or id contains
// "locale" or "language", or whose text is a language name), so a manual
// language choice always sticks.
//
// Limits: rewrites <a> links only. The page source still contains the wrong
// links; scripts that navigate directly are not covered.

(function () {
  'use strict';

  var match = /^\/(en|fr|it|tr)(?=\/|$)/.exec(location.pathname);
  var root = match ? '/' + match[1] : ''; // '' = German (primary) pages

  var BARE_PREFIXES = ['/pages/', '/products/', '/collections/', '/blogs/'];
  var LOCALE_PREFIX_RE = /^\/(en|fr|it|tr)(?=[\/?#]|$)/;
  var SWITCHER_SELECTOR =
    'form[action*="localization"], localization-form, ' +
    '[class*="locale" i], [class*="language" i], [class*="localization" i], ' +
    '[id*="locale" i], [id*="language" i], [id*="localization" i]';
  var LANGUAGE_LABELS = [
    'en', 'english', 'englisch', 'anglais', 'inglese', 'ingilizce',
    'de', 'deutsch', 'german', 'allemand', 'tedesco', 'almanca',
    'fr', 'français', 'francais', 'french', 'französisch', 'franzoesisch', 'francese', 'fransızca', 'fransizca',
    'it', 'italiano', 'italian', 'italienisch', 'italien', 'italyanca',
    'tr', 'türkçe', 'turkce', 'turkish', 'türkisch', 'tuerkisch', 'turc', 'turco'
  ];

  function isSwitcher(a) {
    if (a.hasAttribute('hreflang') || a.hasAttribute('lang')) return true;
    if (a.closest && a.closest(SWITCHER_SELECTOR)) return true;
    var text = (a.textContent || '').replace(/\s+/g, ' ').trim().toLowerCase();
    return LANGUAGE_LABELS.indexOf(text) !== -1;
  }

  function joinPath(prefix, rest) {
    var out = prefix + rest;
    if (out === '') return '/';
    if (out.charAt(0) === '?' || out.charAt(0) === '#') return '/' + out;
    return out;
  }

  // Returns the corrected path, or null when nothing should change.
  function corrected(path) {
    var m = LOCALE_PREFIX_RE.exec(path);
    if (m) {
      if ('/' + m[1] === root) return null; // already correct
      return joinPath(root, path.slice(m[0].length));
    }
    if (root === '') return null;
    if (path === '/') return root;
    for (var i = 0; i < BARE_PREFIXES.length; i++) {
      if (path.indexOf(BARE_PREFIXES[i]) === 0) return root + path;
    }
    return null;
  }

  function fixAnchor(a) {
    var href = a.getAttribute('href');
    if (!href) return;
    var origin = '';
    var path = href;
    if (href.indexOf(location.origin + '/') === 0) {
      origin = location.origin;
      path = href.slice(origin.length);
    }
    if (path.charAt(0) !== '/' || path.charAt(1) === '/') return;
    var next = corrected(path);
    if (next === null) return;
    if (isSwitcher(a)) return;
    a.setAttribute('href', origin + next);
  }

  function run(node) {
    if (!node || node.nodeType !== 1) return;
    if (node.tagName === 'A') fixAnchor(node);
    if (node.querySelectorAll) {
      var anchors = node.querySelectorAll('a[href]');
      for (var i = 0; i < anchors.length; i++) fixAnchor(anchors[i]);
    }
  }

  run(document.documentElement);

  document.addEventListener('shopify:section:load', function (e) {
    run(e.target || document.documentElement);
  });

  if (window.MutationObserver) {
    new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var added = mutations[i].addedNodes;
        for (var j = 0; j < added.length; j++) run(added[j]);
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  // Last resort: fix the link the instant it is clicked.
  document.addEventListener('click', function (e) {
    var a = e.target && e.target.closest ? e.target.closest('a[href]') : null;
    if (a) fixAnchor(a);
  }, true);
})();